<div class="astrea-profile-config">
    <mat-card class="p-2">
        <mat-card-content>

            <div class="astrea-subtitle my-2">
                <h2>{{ 'profile.config.config' | translate }}</h2>
            </div>

            <div class="mt-4">
                <h4>{{ 'profile.config.language_default' | translate }}</h4>
                <form [formGroup]="formLanguage" class="my-2">

                    <mat-form-field class="w-50" appearance="fill">
                        <mat-label>{{ 'profile.config.language' | translate }}</mat-label>
                        <mat-select formControlName="language">
                            <mat-option value="es-ar">{{ 'profile.config.languages.spanish' | translate }}</mat-option>
                            <mat-option value="en-us">{{ 'profile.config.languages.english' | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <button *ngIf="!loadingLanguage" (click)="updateLanguage()" class="btn btn-green ml-3" mat-button>
                        {{ 'save' | translate }}
                    </button>
                    <button *ngIf="loadingLanguage" class="btn btn-green ml-3" mat-button>
                        <astrea-loading></astrea-loading>
                    </button>

                </form>
            </div>

            <div class="mt-2">
                <h4>{{ 'profile.config.divisa_default' | translate }}</h4>
                <form [formGroup]="formCurrency" class="my-2">

                    <mat-form-field class="w-50" appearance="fill">
                        <mat-label>{{ 'profile.config.currency' | translate }}</mat-label>
                        <mat-select formControlName="currency">
                            <mat-option value="ARS">{{ 'profile.config.currencies.argentine_peso' | translate }}</mat-option>
                            <mat-option value="USD">{{ 'profile.config.currencies.dollar' | translate }}</mat-option>
                            <mat-option value="EUR">{{ 'profile.config.currencies.euro' | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <button *ngIf="!loadingCurrency" (click)="updateCurrency()" class="btn btn-green ml-3" mat-button>
                        {{ 'save' | translate }}
                    </button>
                    <button *ngIf="loadingCurrency" class="btn btn-green ml-3" mat-button>
                        <astrea-loading></astrea-loading>
                    </button>

                </form>
            </div>

        </mat-card-content>
    </mat-card>
</div>
